import React from "react";
import "./App.scss";

const add = (a, b) => a + b;
const rnd = () => Math.floor(Math.random() * 1000);

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { seconds: 0 };

    console.log(`Constructor: ${this}`);
  }

  tick() {
    this.setState(state => ({
      seconds: state.seconds + 1,
    }));

    console.log(`Tick: ${this}`);
  }

  componentDidMount() {
    console.log(`Mounted: ${this}`);
    this.interval = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    console.log(`Will unmount: ${this}`);
    clearInterval(this.interval);
  }

  render() {
    return (
      <div className="App">
        {/*  <header className="App-header">
                    <img src={logo} className="App-logo" alt="hot reload test" />
                    <p>
                        Edit <code>aaa.tsx</code>C: {rnd()}  aaa aaa hot aaaa ..{ add(1,5) }.
                    </p>
                    <p>
                        Current time {this.state.seconds}
                    </p>
                </header> */}
      </div>
    );
  }
}

export default App;
